import { CompletionIndicator, ProgressFill } from "./ListProgress";
import type { ListRow } from "./utils";
import { formatDateShort } from "@dashboard/utils/formatDate";
import { useTranslation } from "react-i18next";

type ListCardProps = {
    list: ListRow;
    onOpen: (listId: number) => void;
};

export default function ListCard({ list, onOpen }: ListCardProps) {
    const { i18n } = useTranslation();
    return (
        <li className="rounded-[3px] border border-compendia-border bg-compendia-card px-3 py-3 transition-colors hover:bg-compendia-greige-20 sm:px-4">
            <div className="flex items-start justify-between gap-3">
                <button
                    type="button"
                    onClick={() => onOpen(list.id)}
                    className="min-w-0 flex-1 cursor-pointer text-left text-base font-medium text-compendia-foreground line-clamp-2 wrap-break-word hover:underline"
                >
                    {list.title}
                </button>
                <span className="shrink-0">
                    <CompletionIndicator isCompleted={list.isCompleted} />
                </span>
            </div>

            <div className="mt-3 flex items-center gap-3">
                <div className="min-w-0 flex-1">
                    <ProgressFill row={list} />
                </div>
                <span className="shrink-0 text-label text-compendia-muted">
                    {list.completedTasks}/{list.totalTasks}
                </span>
            </div>

            <div className="mt-3 flex items-center justify-between gap-3">
                <div className="min-w-0 truncate text-label text-compendia-foreground">
                    {list.responsibleUser ? (
                        `${list.responsibleUser.firstName} ${list.responsibleUser.lastName}`
                    ) : (
                        <span className="text-compendia-muted">-</span>
                    )}
                </div>
                <span className="shrink-0 text-label text-compendia-muted">
                    {formatDateShort(new Date(list.createdAt), i18n.language)}
                </span>
            </div>
        </li>
    );
}
